export enum USAGE_STATEMENT_STATUS {
  NOT_PROCESSED = 'not_processed',
  WAITING_DESCRIPTION = 'waiting_description',
  WAITING_LABELING = 'waiting_labeling',
  PROCESSED = 'processed',
  FINISHED = 'finished',
  ERROR = 'error',
  REFUSED = 'refused',
}

export enum USAGE_STATEMENT_STATUS_FULL {
  NOT_PROCESSED = 'not_processed',
  WAITING_DESCRIPTION = 'waiting_description',
  WAITING_LABELING = 'waiting_labeling',
  PROCESSED = 'processed',
  FINISHED = 'finished',
  ERROR = 'error',
  REFUSED = 'refused',
  PENDING = 'pending',
}

export enum LABEL_PROCEDURE_TYPE {
  MAIN = 'main',
  SUB = 'sub',
}
